import { Seo } from '@/components/site/seo';
import { TeamSection } from '@/components/site/sections/team';
import { BannerHero } from '@/components/site/banner-hero';
import { listTeam } from '@/lib/data/public';
import { useLiveData } from '~/hooks/useLiveData';
import { useLocaleContext } from '~/hooks/useLocaleContext';

export default function TeamPage() {
  const { locale, dict } = useLocaleContext();
  const team = useLiveData(listTeam, [locale]).data ?? [];

  return (
    <>
      <Seo
        locale={locale}
        title={dict.team.title}
        description={dict.team.subtitle}
        path="/equipo"
        image="/banners/banner-web-3.jpg"
      />
      <BannerHero image="/banners/banner-web-3.jpg" title={dict.team.title} />
      <TeamSection locale={locale} dict={dict} team={team} compact />
    </>
  );
}
